import { render } from "./WorkGroup.vue?vue&type=template&id=11b54ac1"
import script from "./WorkGroup.vue?vue&type=script&lang=js"
export * from "./WorkGroup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\CAXaAnQuang\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__